import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { IconButton } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2, 0),
    },
    justifyContent: "center",
    marginTop: "20%",
  },
  loader: {
    color: "#f77200",
  },
  retry: {
    width: "100px",
    padding: "10px 15px",
    textAlign: "center",
    background: "#f77200",
    color: "#fff",
    margin: "10px 0",
    border: "none",
    borderRadius: "15px",
    cursor: "pointer",
  },
}));

export default function Loader(props) {
  const classes = useStyles();
  const history = useHistory();

  const [progress, setProgress] = React.useState(0);
  const handleBack = () => {
    history.push("/view-images");
  };
  return (
    <div style={{ width: "100%", float: "left", textAlign: "center" }}>
      <IconButton
        onClick={handleBack}
        className={classes.retry}
        style={{
          float: "left",
          margin: 0,
          background: "transparent",
          color: "#000",
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      <h2>{props.message}</h2>
      <div className={classes.root}>
        {props.errorMsg === "" ? (
          <CircularProgress className={classes.loader} />
        ) : (
          <button
            className={classes.retry}
            onClick={() => {
              window.location.reload(true);
            }}
          >
            Retry
          </button>
        )}
      </div>
      <h5
        style={{
          width: "100%",
          float: "left",
          textAlign: "center",
          color: "red",
        }}
      >
        {props.errorMsg}
      </h5>
    </div>
  );
}
